import * as hooks from './hooks';
import TtamCreativeCtaLabel from './label/index.vue';
import TtamCreativeCtaLabelHint from './label-hint/index.vue';
import TtamCreativeCtaSelect from './select/index.vue';

export default {
  TtamCreativeCtaLabel,
  TtamCreativeCtaLabelHint,
  TtamCreativeCtaSelect,
  ...hooks,
};
